angular
	.module 'App.Module.TicketEvents', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'ticket_events',
				url: '/ticket_events',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@ticket_events":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Shared.Setting.Ticket.Enabled'
					searchParams:
						repositoryName: 'TicketEventRepository'
						title: 'general.ticket_events'

			.state 'ticket_events.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					ticketEvent: (TicketEventRepository, $stateParams) ->
						return TicketEventRepository.getEntity($stateParams.id)

			.state 'ticket_events.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'TicketEventController'
						controllerAs: 'vm'
						templateUrl: '@app/ticket-event/ticket-event.view.html'
